<div class="qform-page">
  <header class="qform-header">
    <img *ngIf="logoUrl" [src]="logoUrl" alt="{{firmName}}" class="qform-logo">
    <span *ngIf="!logoUrl" class="qform-firm-name">{{ firmName }}</span>
  </header>

  <main class="qform-body">
    <div *ngIf="loading" class="qform-status">Loading your questionnaire…</div>

    <div *ngIf="!loading && error && !questions.length" class="qform-status qform-error">
      {{ error }}
    </div>

    <div *ngIf="submitted" class="qform-status qform-success">
      <h2>Thank you{{ clientFirstName ? ', ' + clientFirstName : '' }}!</h2>
      <p>Your questionnaire has been submitted. You can close this window.</p>
    </div>

    <ng-container *ngIf="!loading && !submitted && questions.length">
      <div class="qform-intro">
        <h1>{{ firmName }} Questionnaire</h1>
        <p *ngIf="clientFirstName">Welcome, {{ clientFirstName }}. Please answer the questions below.</p>
        <p *ngIf="lock || done" class="qform-locked-note">
          This questionnaire has been submitted and is now read-only.
        </p>
      </div>

      <nav class="qform-sections" *ngIf="sections.length > 1">
        <button *ngFor="let section of sections; let i = index"
                type="button"
                class="qform-tab"
                [class.active]="i === activeIndex"
                [disabled]="saving"
                (click)="selectSection(i)">
          {{ section.name }}
        </button>
      </nav>

      <div *ngIf="error" class="qform-inline-error">{{ error }}</div>

      <form class="qform-questions" (ngSubmit)="isLastSection ? submit() : saveAndProceed()">
        <div *ngFor="let q of questions" class="qform-question">
          <!-- Not a <label>: questionHtml is rich, block-level content (<p>,
               lists) which is invalid inside a label. Use a div and associate
               each control with it via aria-labelledby (CU-868kqftca). -->
          <div class="qform-label" [id]="'ql-' + q.questionId">
            <span class="qform-qno">{{ q.questionNo }}.</span>
            <!-- render the rich question through Angular's default sanitizer so
                 bold/links/lists and paragraph breaks match the builder and the
                 firm answer view; falls back to plain text -->
            <span class="qform-qtext" [innerHTML]="q.questionHtml || q.question"></span>
            <span *ngIf="q.mandatory" class="qform-required">*</span>
          </div>

          <!-- Short Answer -->
          <input *ngIf="q.type === 'Short Answer'" type="text" class="qform-input" [id]="'qi-' + q.questionId"
                 [attr.aria-labelledby]="'ql-' + q.questionId"
                 [placeholder]="q.placeholder || ''" [(ngModel)]="q.answer" [name]="q.questionId"
                 [disabled]="readOnly">

          <!-- Long Answer -->
          <textarea *ngIf="q.type === 'Long Answer'" class="qform-input qform-textarea" rows="4"
                    [id]="'qi-' + q.questionId" [attr.aria-labelledby]="'ql-' + q.questionId"
                    [placeholder]="q.placeholder || ''" [(ngModel)]="q.answer" [name]="q.questionId"
                    [disabled]="readOnly"></textarea>

          <!-- Date: native date picker; the browser enforces a real date. The
               control binds YYYY-MM-DD, but the answer is stored MM/DD/YYYY, so
               convert on display and on change. -->
          <input *ngIf="q.type === 'Date'" type="date" class="qform-input"
                 [id]="'qi-' + q.questionId" [attr.aria-labelledby]="'ql-' + q.questionId"
                 [name]="q.questionId" [disabled]="readOnly"
                 [value]="toIsoDate(q.dateAnswer)" (change)="onDateChange(q, $event)">

          <!-- Rating -->
          <div *ngIf="q.type === 'Rating'" class="qform-rating" role="group"
               [attr.aria-labelledby]="'ql-' + q.questionId">
            <button *ngFor="let star of [1,2,3,4,5]" type="button" class="qform-star"
                    [attr.aria-label]="star + ' star' + (star === 1 ? '' : 's')"
                    [class.filled]="q.ratingAnswer >= star"
                    (click)="!readOnly && (q.ratingAnswer = star)">★</button>
          </div>

          <!-- Multiple Choice (radio) -->
          <div *ngIf="q.type === 'Multiple Choice'" class="qform-options" role="radiogroup"
               [attr.aria-labelledby]="'ql-' + q.questionId">
            <label *ngFor="let opt of q.multipleOptions" class="qform-option">
              <input type="radio" [name]="q.questionId" [value]="opt.id"
                     [(ngModel)]="q.multipleOptionsAnswer" [disabled]="readOnly">
              {{ opt.value }}
            </label>
          </div>

          <!-- Check Boxes -->
          <div *ngIf="q.type === 'Check Boxes'" class="qform-options" role="group"
               [attr.aria-labelledby]="'ql-' + q.questionId">
            <label *ngFor="let opt of q.checkBoxes" class="qform-option">
              <input type="checkbox" [checked]="opt.checked" [disabled]="readOnly"
                     (change)="toggleCheckbox(q, opt)">
              {{ opt.value }}
            </label>
          </div>

          <!-- attachments -->
          <div class="qform-attachments">
            <div *ngFor="let file of q.attachments; let fi = index" class="qform-attachment">
              <span class="qform-attachment-name">{{ file.name }}</span>
              <button *ngIf="!readOnly" type="button" class="qform-attachment-remove"
                      (click)="removeAttachment(q, fi)">Remove</button>
            </div>
            <label *ngIf="!readOnly" class="qform-attach-btn">
              <span *ngIf="!q.uploading">Attach a file</span>
              <span *ngIf="q.uploading">Uploading…</span>
              <input type="file" class="qform-file-input"
                     accept=".pdf,.doc,.docx,.png,.jpg,.jpeg,.heic"
                     (change)="onFileSelected($event, q)" [disabled]="q.uploading">
            </label>
          </div>
        </div>

        <div class="qform-actions" *ngIf="!readOnly">
          <button type="submit" class="qform-submit" [disabled]="saving">
            <span *ngIf="!saving">{{ isLastSection ? 'Submit' : 'Save & Continue' }}</span>
            <span *ngIf="saving">Saving…</span>
          </button>
        </div>
      </form>
    </ng-container>
  </main>
</div>
